import { render, staticRenderFns } from "./Esporta.vue?vue&type=template&id=535566ad&scoped=true&"
import script from "./Esporta.vue?vue&type=script&lang=js&"
export * from "./Esporta.vue?vue&type=script&lang=js&"
import style0 from "./Esporta.vue?vue&type=style&index=0&id=535566ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535566ad",
  null
  
)

export default component.exports